import React, { useState } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { journalEntriesApi } from '../lib/api';
import { formatCurrency, formatDateTime } from '../lib/utils';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const SearchJournalPage = () => {
  const [entries, setEntries] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ from_date: '', to_date: '', reference: '' });

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await journalEntriesApi.list(filters);
      setEntries(Array.isArray(res.data) ? res.data : res.data?.entries || []);
      setSearched(true);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  return (
    <AdminSubPage title="Search Journal Entries" breadcrumb={['Accounting', 'Search Journal Entries']} backPath="/dashboard/accounting">
      <form onSubmit={handleSearch} className="bg-white border border-gray-200 p-6 max-w-2xl space-y-4 mb-6">
        <div className="grid grid-cols-3 gap-4">
          <div><Label>From Date</Label><Input type="date" value={filters.from_date} onChange={e => setFilters({...filters, from_date: e.target.value})} data-testid="sj-from" /></div>
          <div><Label>To Date</Label><Input type="date" value={filters.to_date} onChange={e => setFilters({...filters, to_date: e.target.value})} data-testid="sj-to" /></div>
          <div><Label>Reference</Label><Input value={filters.reference} onChange={e => setFilters({...filters, reference: e.target.value})} data-testid="sj-ref" /></div>
        </div>
        <Button type="submit" className="bg-[#1f1f1f] text-white" data-testid="sj-search">Search</Button>
      </form>

      {searched && (
        <div className="bg-white border border-gray-200">
          <table className="w-full">
            <thead><tr className="bg-gray-50 border-b">
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Date</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Type</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Account</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Amount</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Description</th>
            </tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={5} className="text-center py-8 text-gray-400">Searching...</td></tr> :
              entries.length === 0 ? <tr><td colSpan={5} className="text-center py-8 text-gray-400">No entries found for the given criteria.</td></tr> :
              entries.map((e, i) => (
                <tr key={i} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600">{e.entry_date || e.created_at?.split('T')[0]}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-2 py-1 rounded ${e.type === 'debit' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>{e.type || 'debit'}</span></td>
                  <td className="px-4 py-3 text-sm text-gray-600">{e.account_name || e.debit_account || '-'}</td>
                  <td className="px-4 py-3 text-sm font-medium">{formatCurrency(e.amount)}</td>
                  <td className="px-4 py-3 text-sm text-gray-600">{e.description || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminSubPage>
  );
};
export default SearchJournalPage;
